
import { mapGetters } from 'vuex'
// import { contactList, customerList } from "@/api/common";
import { addBlankPath } from '@/utils/validate'
import { copyToClip } from '~/utils/index'
export default {
    data() {
        return {
            loading: true,
            dialogVisible: false,
            showService: false,
            gameName: null,
            contactData: [],
            serviceData: []
        }
    },
    computed: {
        ...mapGetters({ gameList: 'game/gameList' })
    },
    methods: {
        join(url) {
            addBlankPath(url)
        },
        getService(item) {
            this.$set(item, 'loading', true)
            const p = {
                action: {
                    gameId: item.id
                }
            }
            this.$api.getImList(p).then((res) => {
                this.$set(item, 'loading', false)
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                if (!res.data.length) {
                    this.$message.error('该游戏暂无客服')
                    return
                }
                this.gameName = item.name
                this.showService = true
                this.serviceData = res.data
            })
        },
        copySuccess(item) {
            copyToClip(item.contact, '已复制')
        },
        getContactList() {
            this.$api.contactList().then((res) => {
                this.loading = false
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.contactData = res.data
            })
        }
    }
}
